<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="addTem">添加活动</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="name"
                label="活动名称"
                align="left"
                min-width="200"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="活动描述"
                align="left"
                min-width="200"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="time"
                label="添加时间"
                align="center"
                width="200"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="username"
                label="添加人"
                align="center"
                width="120"
                fixed="right"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="操作"
                width="300"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-document" size="mini" @click="showActive(scope.row)">详情</el-button>
                  <el-button icon="el-icon-edit" size="mini" @click="editTem(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteTem(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row style="margin-bottom: 10px">
        <el-col>
          <el-form ref="addForm" :model="addForm" :rules="rules" label-position="right" label-width="100px" size="small">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入活动名称" clearable maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="活动描述" prop="name">
              <el-input v-model="addForm.remark" type="textarea" :rows="3" placeholder="请输入活动描述" clearable maxlength="200" show-word-limit />
            </el-form-item>
            <el-form-item label="填写信息" prop="option">
              <el-button type="primary" size="mini" icon="el-icon-plus" style="margin-bottom: 20px" @click="addOption">添加选项</el-button>
              <el-form-item
                v-for="(opt, index) in addForm.option"
                v-model="opt[index]"
                :prop="'option.'+index + '.optionName'"
                :rules="{required: true, message: '请输入选项内容', trigger: 'blur'}">
                <el-row>
                  <el-col :span="10">
                    <el-input placeholder="请输入选项标题" v-model="opt.optionName" maxlength="50">
                      <el-select v-model="opt.type" slot="prepend" placeholder="请选择" style="width:100px">
                        <el-option label="输入框" :value="0"></el-option>
                        <el-option label="选项" :value="1"></el-option>
                        <el-option label="地区" :value="2"></el-option>
                      </el-select>
                      <div slot="append" style="width: 100px;position: relative">
                        <el-checkbox v-model="opt.fill">必填</el-checkbox>
                        <el-button style="position: absolute;right: 0;top: 4px" :disabled="index===0" icon="el-icon-delete" @click.prevent="deleteOption(index)"></el-button>
                      </div>
                    </el-input>
                  </el-col>
                  <el-col :span="14">
                    <el-select
                      v-model="opt.child"
                      v-if="opt.type===1"
                      multiple
                      filterable
                      allow-create
                      style="width: 100%"
                      placeholder="请输入选项子项名称">
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form-item>
          </el-form>
          <div style="float: right">
            <el-button type="primary" size="mini" icon="el-icon-document-checked" :loading="btnLoading" @click="submitTem">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="活动签到二维码"
      :visible.sync="innerQr"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      @close="closeCode">
      <el-row style="margin-bottom: 20px">
        <el-col>
          <div align="center">
            <div id="qrcode" ref="qrcode"></div>
            <i class="el-icon-info" style="margin-top: 20px" /><el-tag>右键单击选择图片另存为</el-tag>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="活动签到详情"
      :visible.sync="showActiveVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row style="margin-bottom: 20px">
        <el-col>
          <div style="float: right">
            <el-button icon="el-icon-paperclip" size="small" @click="getQrCode(addForm.acid)">生成二维码</el-button>
            <el-button icon="el-icon-document" size="small" :loading="exportLoading" @click="exportExcel(addForm.acid)">导出Excel</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 20px">
        <el-col>
          <div>
            <el-table :data="info" style="width: 100%" height="400">
              <el-table-column
                label="序号"
                width="100"
                align="center">
                <template scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <template v-for="item of title">
                <el-table-column
                  :prop="item.prop"
                  :label="item.name"
                  width="200"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import qs from 'qs'
import Qrcode from 'qrcodejs2'
import {
  addOrEditActiveCheck,
  deleteActiveCheck, exportActiveCheckOfferExcel, getActiveCheckList,
  getActiveCheckUserInfo,
  getInfoOption
} from '@/api/work'
export default {
  name: 'delhdqd',
  data() {
    return {
      searchForm: {
        search: ''
      },
      innerQr: false,
      showActiveVisible: false,
      qrcode: null,
      qr: null,
      exportLoading: false,
      loading: false,
      btnLoading: false,
      total: 0,
      pageSize: 20,
      currentPage: 1,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      addForm: {
        acid: null,
        name: '',
        remark: '',
        option: [{
          optionName: '',
          xuHao: 1,
          type: 0,
          fill: true,
          child: []
        }]
      },
      title: [],
      info: [],
      count: 1,
      rules: {
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入活动描述', trigger: 'blur' }],
        option: [{ required: true }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.pageSize = 20
      this.getData()
    },
    getQrCode(acid) {
      this.innerQr = true
      this.qrcode = 'https://www.mulu.life/activeCheck/' + acid
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.crateQrcode()
      })
    },
    crateQrcode() {
      this.qr = new Qrcode('qrcode', {
        width: 150,
        height: 150, // 高度
        text: this.qrcode // 二维码内容
      })
    },
    closeCode() {
      this.$refs.qrcode.innerHTML = ''
    },
    getData() {
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.searchForm.search,
        userid: this.user.userid,
        role: this.user.rank
      }
      this.loading = true
      getActiveCheckList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    addTem() {
      this.dialogTitle = '添加活动签到'
      this.addForm.acid = '0'
      this.addForm.name = ''
      this.addForm.remark = ''
      this.addForm.option = [{
        optionName: '',
        xuHao: 1,
        type: 0,
        fill: true,
        child: []
      }]
      this.dialogVisible = true
    },
    editTem(row) {
      this.dialogTitle = '编辑活动签到'
      getInfoOption({ acid: row.acid }).then(response => {
        this.addForm.option = []
        for (const option of response.data) {
          let _child = []
          if (option.type === 1) {
            for (const c of option.child) {
              _child.push(c.name)
            }
          }
          this.addForm.option.push({
            optionName: option.oname,
            xuHao: option.xuhao,
            type: option.type,
            fill: option.fill === 1 ? true : false,
            child: _child
          })
        }
        this.addForm.acid = row.acid
        this.addForm.name = row.name
        this.addForm.remark = row.remark
        this.dialogVisible = true
      }).catch(() => {})
    },
    deleteTem(row) {
      this.$confirm('您确定要删除此活动签到吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deleteActiveCheck({ acid: row.acid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    submitTem() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            let _option = []
            for (const o of this.addForm.option) {
              _option.push({
                optionName: o.optionName,
                xuHao: o.xuHao,
                type: o.type,
                fill: o.fill ? 1 : 2,
                child: o.type === 1 ? o.child : []
              })
            }
            const optionList = qs.parse(_option)
            const data = {
              acid: this.addForm.acid,
              name: this.addForm.name,
              remark: this.addForm.remark,
              optionForm: optionList,
              userid: this.user.userid,
              role: this.user.rank
            }
            this.btnLoading = true
            addOrEditActiveCheck(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    exportExcel(acid) {
      if (!this.exportLoading) {
        this.exportLoading = true
        exportActiveCheckOfferExcel({ acid: acid }).then(response => {
          this.exportLoading = false
          const _this = this
          const xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              const blob = this.response
              const a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    addOption() {
      this.addForm.option.push({
        optionName: '',
        type: 0,
        xuHao: this.count + 1,
        fill: true,
        child: []
      })
      this.count = this.addForm.option.length
    },
    deleteOption(index) {
      if (index !== -1) {
        this.addForm.option.splice(index, 1)
      }
    },
    showActive(row) {
      this.title = []
      this.info = []
      this.addForm.acid = row.acid
      getActiveCheckUserInfo({ acid: row.acid }).then(response => {
        this.info = response.data.infoList
        this.title = response.data.titleList
      }).catch(() => {})
      this.showActiveVisible = true
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style scoped>
</style>
